import type { FC } from 'react';

import useRole from '@zen/Auth/hooks/useRole';
import useGlobalPermissions from '@zen/Auth/useGlobalPermissions';
import { useFeatureIsOn } from '@zen/FeatureFlag';
import { Role } from '@zen/Networks/types';

import SidebarLinks from '../components/SidebarLinks';
import type { SidebarCounters } from '../types';
import { getConfig } from './config';
import type { CustomerLinksFeatureFlags } from './types';

interface Props {
  counters: SidebarCounters;
}

const CustomerLinks: FC<Props> = ({ counters }) => {
  const isAskZenseiEnabled: boolean = useFeatureIsOn('ask-zensei');
  const isBookingsPageEnabled: boolean = useFeatureIsOn('bookings-page');
  const isFinancialsEnabled: boolean = useFeatureIsOn('frontend-financials');
  const isFreightSpendEnabled: boolean = useFeatureIsOn('freight-spend');
  const isQuotesPageEnabled: boolean = useFeatureIsOn('quotes-page');
  const isRateCardsEnabled: boolean = useFeatureIsOn('rate-cards');
  const isShipmentsPageEnabled: boolean = useFeatureIsOn('shipments-page');
  const isUtilisationEnabled: boolean = useFeatureIsOn('utilisation');

  const role = useRole();
  const { check } = useGlobalPermissions();

  const canViewApiConsole = check('apiConsole.canAccessRoute') || role === Role.AGENT_FORWARDER;
  const canAccessFreightSpend = check('insights.freightSpendCanAccessRoute');

  const featureFlags: CustomerLinksFeatureFlags = {
    isAskZenseiEnabled,
    isBookingsPageEnabled,
    isFinancialsEnabled,
    isFreightSpendEnabled,
    isQuotesPageEnabled,
    isRateCardsEnabled,
    isShipmentsPageEnabled,
    isUtilisationEnabled
  };

  const config = getConfig(canViewApiConsole, canAccessFreightSpend, featureFlags, role);

  return <SidebarLinks config={config} counters={counters} />;
};

export default CustomerLinks;
